module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.f8fe32d3.ttf";